import { useState } from 'react'
import { supabase } from '@/lib/supabase'
import { Logo } from '@/components/ui/Logo'

export default function CheckEmail() {
  const email = localStorage.getItem('dt_signup_email') ?? ''

  const [resending, setResending] = useState(false)
  const [resent,    setResent]    = useState(false)

  const handleResend = async () => {
    if (resending || !email) return
    setResending(true)
    try {
      await supabase.auth.resend({ type: 'signup', email })
      setResent(true)
    } finally {
      setResending(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#FAF6EF', padding: '24px 16px',
    }}>
      <div style={{ width: '100%', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
          <Logo size={60} />
        </div>

        {/* Envelope icon */}
        <div style={{
          width: 64, height: 64, borderRadius: '50%',
          background: 'rgba(15,124,108,0.1)', border: '2px solid #0F7C6C',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <svg width='28' height='28' viewBox='0 0 24 24' fill='none'>
            <rect x='2' y='4' width='20' height='16' rx='2' stroke='#0F7C6C' strokeWidth='2'/>
            <path d='M2 7l10 7 10-7' stroke='#0F7C6C' strokeWidth='2' strokeLinecap='round'/>
          </svg>
        </div>

        <div style={{ font: '600 22px Lora,serif', color: '#1B2A4A', marginBottom: 8 }}>
          Check your inbox
        </div>
        <div style={{ font: '400 14px/1.6 Inter,sans-serif', color: 'rgba(27,42,74,0.6)', marginBottom: 6 }}>
          We've sent a confirmation email to
        </div>
        {email && (
          <div style={{ font: '600 14px Inter,sans-serif', color: '#1B2A4A', marginBottom: 24 }}>
            {email}
          </div>
        )}
        <div style={{ font: '400 13px/1.6 Inter,sans-serif', color: 'rgba(27,42,74,0.5)', marginBottom: 32 }}>
          Click the link in the email to confirm your account. The link expires in 24 hours.
        </div>

        {resent ? (
          <div style={{
            padding: '12px 20px', background: 'rgba(15,124,108,0.08)', border: '1px solid rgba(15,124,108,0.2)',
            borderRadius: 10, font: '400 13px Inter,sans-serif', color: '#0F7C6C', marginBottom: 16,
          }}>
            Email resent — check your inbox again.
          </div>
        ) : (
          <button
            onClick={handleResend}
            disabled={resending}
            style={{
              width: '100%', padding: '12px 20px', marginBottom: 12,
              background: '#0F7C6C', border: 'none', borderRadius: 10,
              font: '600 14px Inter,sans-serif', color: '#fff',
              cursor: resending ? 'not-allowed' : 'pointer', opacity: resending ? 0.6 : 1,
            }}
          >
            {resending ? 'Sending…' : 'Resend confirmation email'}
          </button>
        )}

        <div style={{ font: '400 12px Inter,sans-serif', color: 'rgba(27,42,74,0.35)', marginTop: 16 }}>
          Didn't receive it? Check your spam folder.
        </div>
      </div>
    </div>
  )
}
